// import React, { useEffect } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchBanners } from "../../redux/features/headerBannerSlice";
// import Banner1 from '../../assets/img/carousel-1.jpg'
// import Banner2 from '../../assets/img/carousel-2.jpg'

// function Header() {
//   const dispatch = useDispatch();
//   const { banners } = useSelector((state) => state.banners);

//   const settings = {
//     dots: true,
//     infinite: true,
//     vertical: true, // Enable vertical sliding
//     verticalSwiping: true, // Allow swiping vertically
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false, // Enable navigation buttons
//     nextArrow: <VerticalNextArrow />, // Custom Next Arrow
//     prevArrow: <VerticalPrevArrow />, // Custom Prev Arrow
//   };

//   // Dispatch the fetchBanners action when the component mounts
//   useEffect(() => {
//     dispatch(fetchBanners()); // This will trigger the API call
//   }, [dispatch]);

//   return (
//     <main className="main-bg">
//       <section className="hero-section mb-0">
//         <div className="hero-wrapper-one">
//           <div className="container">
//             <Slider {...settings} className="hero-slider-one">

//               {Array.isArray(banners) && banners.length > 0 ? (
//                 banners.map((banner) => (
//                   <div key={banner.id} className="single-hero-slider">
//                     <div className="row align-items-center">
//                       <div className="col-lg-6">
//                         <div className="hero-content style-one mb-50">
//                           <span className="sub-heading">
//                             {banner.sub_title || "Best for your categories"}
//                           </span>
//                           <h1>
//                             {banner.title || "Exclusive Collection"} <br />
//                             in <span>Our Online</span> Store
//                           </h1>
//                           <p>
//                             Discover our exclusive collection available only in
//                             our online store. Shop now for unique and premium
//                             items that you won't find anywhere else.
//                           </p>
//                           <a href="shops" className="theme-btn style-one">
//                             Shop Now
//                           </a>
//                         </div>
//                       </div>
//                       <div className="col-lg-6">
//                         <div className="hero-image-box">
//                           <div className="hero-image">
//                             <img
//                               src={
//                                 banner.image || "https://default-image-url.com"
//                               }
//                               alt={banner.title || "Hero Image"}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (<></>
//                 // <div>No banners available</div> // Fallback message if banners are empty or not an array
//               )}
//             </Slider>
//           </div>
//         </div>
//       </section>

//       <section className="features-section pt-130">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div
//                 className="features-wrapper aos-init aos-animate"
//                 data-aos="fade-up"
//                 data-aos-delay="10"
//                 data-aos-duration="1000"
//               >
//                 <div className="iconic-box-item icon-left-box mb-25">
//                   <div className="icon">
//                     <i className="fas fa-shipping-fast"></i>
//                   </div>
//                   <div className="content">
//                     <h5>Free Shipping</h5>
//                     <p>You get your items delivered without any extra cost.</p>
//                   </div>
//                 </div>

//                 <div className="iconic-box-item icon-left-box mb-25">
//                   <div className="icon">
//                     <i className="fas fa-microphone"></i>
//                   </div>
//                   <div className="content">
//                     <h5>Great Support 24/7</h5>
//                     <p>
//                       Our customer support team is available around the clock{" "}
//                     </p>
//                   </div>
//                 </div>

//                 <div className="iconic-box-item icon-left-box mb-25">
//                   <div className="icon">
//                     <i className="far fa-handshake"></i>
//                   </div>
//                   <div className="content">
//                     <h5>Return Available</h5>
//                     <p>
//                       Making it easy to return any items if you're not
//                       satisfied.
//                     </p>
//                   </div>
//                 </div>

//                 <div className="iconic-box-item icon-left-box mb-25">
//                   <div className="icon">
//                     <i className="fas fa-sack-dollar"></i>
//                   </div>
//                   <div className="content">
//                     <h5>Secure Payment</h5>
//                     <p>Shop with confidence knowing that our secure payment</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </main>
//   );
// }

// function VerticalNextArrow(props) {
//   const { className, onClick } = props;
//   return (
//     <div
//       className={`${className} vertical-arrow vertical-next`}
//       onClick={onClick}
//     >
//       ↓
//     </div>
//   );
// }

// function VerticalPrevArrow(props) {
//   const { className, onClick } = props;
//   return (
//     <div
//       className={`${className} vertical-arrow vertical-prev`}
//       onClick={onClick}
//     >
//       ↑
//     </div>
//   );
// }

// export default Header;
import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchBanners } from "../../redux/features/headerBannerSlice";
import { FaSpinner } from "react-icons/fa";

function Header() {
  const dispatch = useDispatch();
  const { banners, loading } = useSelector((state) => state.banners);
  const lang = useSelector((state) => state.language.lang);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000
  };

  useEffect(() => {
    dispatch(fetchBanners(lang));
  }, [dispatch, lang]);

  const slides = Array.isArray(banners) && banners.length > 0
    ? banners.map(b => ({
      id: b?.id,
      title: b?.title || "",
      subTitle: b?.sub_title || "",
      image: b?.image
    }))
    : [];

  return (
    <main className="main-bg">
      <section className="hero-section mb-0 px-3 pt-3 pb-4 p-md-4">

        {/* Loader while fetching */}
        {loading && (
          <></>
        )}

        {/* Slider only when loaded and data exists */}
        {!loading && slides.length > 0 && (
          <Slider {...settings} className="hero-slider-one" style={{ borderRadius: "8px" }}>
            {slides.map(slide => (
              <div key={slide.id} style={{ borderRadius: "8px", }}>
                <div
                  className="full-banner-slide responsive-banner"
                  style={{
                    backgroundImage: `url(${slide.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "flex",
                    alignItems: "center",
                    paddingTop: "4rem",
                    paddingBottom: "4rem",
                    borderRadius: "8px",
                    position: "relative",
                    color: "#fff"
                  }}
                >
                  {/* Text Container */}
                  <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="hero-content-box text-left">
                      <div className="col-12 col-sm-6">
                        {/* old not commented (28-10-2025) */}
                        {/* <span className="sub-heading" style={{ color: "#f0f0f0" }}>
                        {slide.subTitle}
                      </span>
                      <h1 className="col-12" style={{ color: "#ffcc00", fontWeight: "700" }}>
                        {slide.title}
                      </h1> */}
                        {/*<p style={{ color: "#e0e0e0", paddingBottom: '1rem' }}>
                        Discover our exclusive collection available only in our online
                        store. Shop now for unique and premium items that you won't find
                        anywhere else.
                      </p>
                      <a href="shops" className="theme-btn style-one">
                        Shop Now
                      </a> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        )}

      </section>
    </main>
  );
}

export default Header;
